import { useQuery } from '@tanstack/react-query';
import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { ChangeEventHandler, createRef, useMemo } from 'react';

import { loadCurrencies } from '../../modules/currency-selector';
import IconSelect from '../../ui/icons/select';
import IconSelectFilter from '../../ui/icons/select_filter';

type TSort = {
  hideMobile?: boolean;
  hideDesktop?: boolean;
  onChange?: ChangeEventHandler<HTMLSelectElement> | undefined;
};

const Sort = ({ hideMobile = true, hideDesktop = false, onChange }: TSort) => {
  const {
    locale = 'en',
    query: { sort = 'price-asc' },
  } = useRouter();
  const { t } = useTranslation();

  const { data: currencies } = useQuery(
    ['user-dependent', 'currencies-list', locale],
    loadCurrencies
  );

  const currency = useMemo(() => {
    if (currencies) {
      const currentCurrency = currencies.find((c) => c.selected);
      return currentCurrency;
    }

    return undefined;
  }, [currencies]);

  return (
    <div
      className={cx(
        'relative',
        //'flex-row-reverse',
        'items-center group',
        hideMobile ? 'hidden' : 'flex flex-row',
        hideDesktop ? 'lg:hidden' : 'lg:flex lg:flex-row',
        'pr-0',
        'hover:bg-brand-10',
        'hover:text-brand-100',
        'gap-2'
      )}
    >
      <select
        id="select-options"
        className={cx(
          'py-4',
          'lg:py-4',
          'pl-4',
          'max-lg:px-0 max-lg:pl-2',
          'text-sm',
          'leading-4',
          'cursor-pointer',
          'appearance-none',
          'bg-transparent',
          'focus:outline-none w-fit'
        )}
        data-cy="select-sort"
        value={sort || 'price-asc'}
        onChange={(e) => {
          if (onChange) {
            onChange(e);
          }
        }}
      >
        <option value="performance">{t('products:sort.recommended')}</option>
        <option value="price-asc">
          {t('products:sort.price', {
            currency: currency?.symbol || '',
          })}{' '}
          {t('products:sort.ascending')}
        </option>
        <option value="price-desc">
          {t('products:sort.price', {
            currency: currency?.symbol || '',
          })}{' '}
          {t('products:sort.descending')}
        </option>
        <option value="id-desc">{t('products:sort.most-recent')}</option>
        <option value="delivery-asc">{t('products:sort.delivery-asc')}</option>
      </select>
      <div
        className={cx(
          'w-[24px] lg:w-[32px] h-12 z-[1]',
          'flex justify-start items-center'
        )}
      >
        <IconSelectFilter
          className={cx(
            'w-4',
            'h-4',
            'cursor-pointer group-hover:text-brand-100'
          )}
        />
      </div>
    </div>
  );
};

export default Sort;
